import { render } from "./MainSlide.vue?vue&type=template&id=7ad987e8&scoped=true"
import script from "./MainSlide.vue?vue&type=script&lang=js"
export * from "./MainSlide.vue?vue&type=script&lang=js"

import "./MainSlide.vue?vue&type=style&index=0&id=7ad987e8&scoped=true&lang=scss"

import exportComponent from "E:\\dive\\dive.fsd.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad987e8"]])

export default __exports__